
import Answer from './answer.vue'
import Research from './research'
import AiInput from './ai-input'
import AiLogo from '../ai-logo.vue'

export default {
  components: {
    Answer, Research, AiInput, AiLogo
  },
  props: {
    item: {type: Object, required: true},
    lastAnswer: {type: Boolean, default: false},
    generating: {type: Boolean, default: false},
  },
  emits: ['text-added', 'completed', 'ask-ai'],

  data() {
    return {
      typing: false,
      completed: false,
      animate_logo: false
    }
  },
  computed: {
    loading(){
      return this.generating || this.typing
    },
    status(){
      return this.item.data?.status || 'Thinking...'
    },
    text(){
      return this.item.data?.text
    },
    input() {
      return this.item.data?.input
    },
  },
  watch: {
    loading(){
      if (!this.loading) {
        this.animate_logo = false
      }
    }
  },
  mounted() {
    this.animate_logo = this.loading && this.lastAnswer
  },
  methods: {
    onTextAdded(full) {
      this.typing = !full
      this.$nextTick(() => this.$emit('text-added', full))
    },
    onStart(){
      this.completed = true
      this.$emit('completed', this.item.data.extracted_info)
    },
  }
}
